import { render } from "./lead-sources.vue?vue&type=template&id=3d52138b"
import script from "./lead-sources.vue?vue&type=script&lang=js"
export * from "./lead-sources.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__